import React, { useState } from 'react';
import Checkbox from '../Checkbox';
import { withInjectedProps } from '../InjectedPropsContext';
import './CheckboxGroup.scss';

export interface ICheckboxGroupProps<TValue = any> {
  disabled?: true;
  options?: Array<{ name?: string; value?: TValue; label?: string; disabled?: boolean }>;
}

let idCounter = 0;
/**
 * An alternative to dropdowns for displaying a list of options.
 * This implementation follows the dropdown component. Try to keep them consistent for ease of use.
 */
const CheckboxGroupBase: React.FC<ICheckboxGroupProps> = ({ disabled, options }) => {
  const checkboxGroupId = useState(idCounter++);

  return (
    <div className="CheckboxGroup">
      {options &&
        options.map(({ name, label, value, disabled: optionDisabled }, i) => (
          <Checkbox
            disabled={optionDisabled || disabled}
            key={i}
            name={name || `CheckboxGroup-${checkboxGroupId}`}
            label={label}
            value={value}
          />
        ))}
    </div>
  );
};

const CheckboxGroup = withInjectedProps(CheckboxGroupBase);

export { CheckboxGroup, CheckboxGroupBase };
export default CheckboxGroup;
